import axiosInstance from '../../axiosInstance';

/** Unified customer profile routes (same as monolith `userRoutes` / `verifyUsersMe`). */
const USERS_ME = '/api/users/me';

export async function putEndUserMe(body) {
  const res = await axiosInstance.put(USERS_ME, body, {
    withCredentials: true,
  });
  return res.data;
}

export async function postEndUserPasswordVerify(currentPassword) {
  const res = await axiosInstance.post(
    `${USERS_ME}/password/verify`,
    { currentPassword },
    { withCredentials: true }
  );
  return res.data;
}

export async function postEndUserPasswordChange(currentPassword, newPassword) {
  const res = await axiosInstance.post(
    `${USERS_ME}/password/change`,
    { currentPassword, newPassword },
    { withCredentials: true }
  );
  return res.data;
}
